module.exports = __webpack_public_path__ + "img/cloud_tool_chord.eb00e6de.jpg";